/**
 * Created by tomers on 3/1/2015.
 */
define(function (require) {
    "use strict";

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var AgentStateAnchorView = require("personalization-web-agent-views/AgentStateAnchorView");
    var SiteSettingsModel = require("models/SiteSettingsModel");
    var Settings = require("codeTables/settings.json");

    var AgentStateController = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {

        AgentStateController = BaseFeatureController.extend({
            initialize: function (options) {
                this._initialize(options);
            },

            getAnchorView: function() {
                return this._getAnchorView();
            },

            _initialize: function(options) {
                LEPersonalization.logger.info("initializing", "AgentStateController:_initialize", options);
                this.featuresToEdit = options.featureOptions.editController.FEATURES_TO_EDIT;
                this.featureId = options.featureOptions.id;

                this._createView(options);
                this._bindEvents();
                this._fetchData();
            },

            _createView: function(options) {
                LEPersonalization.logger.debug("create the anchor view", "AgentStateController:_createView");
                this.agentStateView = new AgentStateAnchorView({
                    anchorSelector: options.featureOptions.anchorSelector,
                    featureId: options.featureId
                });

                LEPersonalization.logger.debug("the created anchor view", "AgentStateController:_createView", this.agentStateView);
            },

            _getAnchorView: function () {
                return this.agentStateView;
            },

            _bindEvents: function() {
                LEPersonalization.logger.debug("binding events", "AgentStateController:_bindEvents");
                this.listenTo(this.agentStateView, "navigateToDefaultAgentStateEdit", this._onNavigateToDefaultAgentStatusEdit);
                this.listenTo(this.agentStateView, "navigateToMultipleAgentStateEdit", this._onNavigateToMultipleAgentStateEdit);
            },

            _fetchData: function() {
                this._fetchSiteSettingsModel();
                this._fetchAgentReasons();
            },

            _fetchSiteSettingsModel: function(){
                this.siteSettingsModel = new SiteSettingsModel({
                    id: Settings.SETTING_ID.DEFAULT_AGENT_STATUS,
                    contextType: Settings.CONTEXT_TYPE.ACCOUNT,
                    contextCascading: true
                });

                this.siteSettingsModel.fetch({
                    success: _.bind(this._onSiteSettingsModelFetchSuccess, this),
                    error: _.bind(this._onSiteSettingsModelFetchError, this)
                });
            },

            _onSiteSettingsModelFetchSuccess: function(model, response, options) {
                LEPersonalization.logger.debug("When site settings model fetch was successful", "AgentStateController:_onSiteSettingsModelFetchSuccess. response = " + response);
                this.currentDefaultAgentStatus = LE.siteSettings.agentStatusSettings.getCurrentDefaultAgentStatusObject(this.siteSettingsModel.getValue());
                this.agentStateView.updateDefaultLoginStatusAfterFetch(this.currentDefaultAgentStatus);
            },

            _onSiteSettingsModelFetchError: function(model, response, options) {
                LEPersonalization.logger.debug("When site settings model fetch has resulted with an error", "AgentStateController:_onSiteSettingsModelFetchError. response = " + response);
                LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
            },

            _fetchAgentReasons: function() {
                this.agentReasonsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAgentReasonsCollection);

                if (this.agentReasonsCollection.isCollectionAllowed()) {
                    this.agentReasonsCollection.fetch({
                        success: _.bind(this._onFetchAgentReasonsFetchSuccess, this),
                        error: _.bind(this._onFetchAgentReasonsFetchError, this)
                    });
                }
                else {
                    this.agentStateView.updateAgentReasonsAfterFetch(false);
                }
            },

            _onFetchAgentReasonsFetchSuccess: function(collection, response, options) {
                LEPersonalization.logger.debug("When agent reasons collection fetch was successful", "AgentStateController:_onFetchAgentReasonsFetchSuccess. response = " + response);
                this.agentStateView.updateAgentReasonsAfterFetch(true, this.agentReasonsCollection);
            },

            _onFetchAgentReasonsFetchError: function(collection, response, options) {
                LEPersonalization.logger.warn("When agent reasons fetch has resulted with an error", "AgentStateController:_onFetchAgentReasonsFetchError. response = " + response);
                LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
            },

            _onNavigateToDefaultAgentStatusEdit: function () {
                LEPersonalization.logger.info("navigate to feature edit", "AgentStateController:_onNavigateToDefaultAgentStatusEdit");
                LEPersonalization.navigateToFeatureEdit({
                    featureId: this.featureId,
                    controllerOptions:{
                        currentDefaultAgentStatus: this.currentDefaultAgentStatus,
                        siteSettingsModel: this.siteSettingsModel,
                        featureToEdit: this.featuresToEdit.DEFAULT_LOGIN_STATUS
                    }
                });
            },

            _onNavigateToMultipleAgentStateEdit: function () {
                LEPersonalization.logger.info("navigate to feature edit", "AgentStateController:_onNavigateToMultipleAgentStateEdit");
                LEPersonalization.navigateToFeatureEdit({
                    featureId: this.featureId,
                    controllerOptions:{
                        agentReasonsCollection: this.agentReasonsCollection,
                        featureToEdit: this.featuresToEdit.AWAY_REASONS
                    }
                });
            },

            _onFetchSuccess: function (model, response, options) {
                LEPersonalization.logger.debug("When data fetch was successful", "AgentStateController:_onFetchSuccess. response = " + response);
                this.currentDefaultAgentStatus = LE.siteSettings.agentStatusSettings.getCurrentDefaultAgentStatusObject(this.siteSettingsModel.getValue());
                this.agentStateView.updateDefaultLoginStatusAfterFetch(this.currentDefaultAgentStatus);
            },

            _onFetchError: function (model, response, options) {
                LEPersonalization.logger.debug("When data fetch has resulted with an error", "AgentStateController:_onFetchError. response = " + response);
                LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
            }
        });
    });
    return AgentStateController;

});
